import React, { FC } from 'react';
import type { StepPageProps } from '../../../assessment-portal';
import { useAssessmentPortalState } from '../../../assessment-portal';
import useQuestionnaireSubmission from '../../hooks/use-questionnaire-submission';
import { AdhdQuestionnaireFlowStep } from '../../data/constants';
import type { AdhdQuestionnaireFlowState } from '../../types/flow';
import type { SubmissionState } from '../../hooks/submission-state';
import { DUPLICATE_PATIENT_MESSAGE } from '../../hooks/submission-state';
import IdentityConfirmPage from '../identity-confirm-page';

const resolveErrorMessage = (state: SubmissionState): string | undefined => {
  if (state.status !== 'error') return undefined;
  if (state.failure.kind === 'patient-not-found') {
    return 'We couldn\'t find a booking matching that name and date of birth. Please check your details and try again.';
  }
  if (state.failure.kind === 'duplicate-patient') {
    return DUPLICATE_PATIENT_MESSAGE;
  }
  if (state.failure.kind === 'validation') {
    return state.failure.message;
  }
  if (state.failure.kind === 'unknown') {
    return state.failure.message;
  }
  return undefined;
};

const IdentityConfirmStep: FC<StepPageProps> = ({ onBack }) => {
  const {
    flowState,
    updateFlowState,
    goToStep,
  } = useAssessmentPortalState<AdhdQuestionnaireFlowState>();

  const {
    state,
    handleSubmitQuestionnaire,
    resetSubmitError,
  } = useQuestionnaireSubmission(flowState);

  return (
    <IdentityConfirmPage
      initialValues={flowState.identityConfirm}
      submitting={state.status === 'submitting'}
      errorMessage={resolveErrorMessage(state)}
      onBack={onBack}
      onSubmit={(values) => {
        resetSubmitError();
        updateFlowState('identityConfirm', values);
        handleSubmitQuestionnaire(values, (completionDisplay) => {
          updateFlowState('completionDisplay', completionDisplay);
          updateFlowState('submissionResult', { isSuccess: true, errorMessage: '' });
          goToStep(AdhdQuestionnaireFlowStep.COMPLETION);
        });
      }}
    />
  );
};

export default IdentityConfirmStep;
